export const RECEIVE_NOTE_ITEM_DIALOG = 'receiveNoteItemDialog';
export const REPLACE_ARTICLE_DIALOG = 'replaceArticleDialog';
